module.exports = "@media screen and (max-width: 640px) {\n    .modal-content {\n        max-height: 350px !important;\n    }\n    md-dialog-container {\n        max-width: 80vw !important;\n    }\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/playlists/edit-playlist/edit-playlist.component.css
// module id = ./src/app/playlists/edit-playlist/edit-playlist.component.css
// module chunks = main